<template>
  <custom-dialog
    width="600px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <el-form>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('asm_part_img_dialog.jljtp')">
              <t-upload
                :bizId="bizId"
                bizType="asm.service.part.old"
                v-model="oldAttachList"
                :limit="3"
                :autoUpload="false"
                :ref="`asmServicePartOld`"
                :disabled="true"
              ></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('asm_part_img_dialog.xljtp')">
              <t-upload
                :bizId="bizId"
                bizType="asm.service.part.new"
                v-model="newAttachList"
                :limit="3"
                :autoUpload="false"
                :ref="`asmServicePartOld`"
                :disabled="true"
              ></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload.vue';

/**
 * 查看零件新旧图片dialog
 */
export default {
  mixins: [dialogMixins],
  components: {
    tUpload
  },
  props: {
    bizId: String,
  },
  data() {
    return {
      oldAttachList: [],
      newAttachList: [],
    };
  },
  mounted() {
  },
  methods: {
    init() {

    },
    onConfirm() {
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss"></style>
